<template>
  <v-container>
    
    <v-row>
      <v-col lg="12">
        <list></list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import List from "@/components/presumptive/referral/List.vue";
export default {
  components: {
    
    "list":List,
  },
  methods: {
    submitForm(data) {
      data.township_id = this.$route.params.township_id;
      this.$store.dispatch("PresumptiveRefer/save", data);
    }
  },
  created() {
    this.$store.dispatch("PresumptiveRefer/getAll", {
      township_id: this.$route.params.township_id
    });
  },
 
};
</script>

<style>
</style>